export default "__VITE_ASSET__Dwp5VKXY__"